var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuMydetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210.005,
    height: 150,
    viewBox: "0 0 210.005 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ec008c;}.b{fill:#e6e6e6;}.c{fill:#f8d7d7;}.d{fill:#fbae47;}.e{fill:#2f2e41;}.f{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-382.004 -236.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 132.377,
    height: 92.564,
    transform: "translate(459.633 258.897)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 88.11,
    cy: 3.723,
    rx: 88.11,
    ry: 3.723,
    transform: "translate(382.004 379.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M665.46,441.654a4.077,4.077,0,0,0-.085.611l-15.293,9.225-3.717-2.238-3.963,5.425,7.952,5.927L667.8,446.211a3.63,3.63,0,0,0,4.115-1.1,4.049,4.049,0,0,0,.473-4.414,3.694,3.694,0,0,0-3.781-2.025A3.8,3.8,0,0,0,665.46,441.654Z",
    transform: "translate(-208.279 -175.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M605.737,446.766l12.041,8.974,5.386-7.061-11.705-9.821a4.6,4.6,0,0,0-3.62-1.044,4.715,4.715,0,0,0-3.212,2.034h0a5.107,5.107,0,0,0,1.11,6.918Z",
    transform: "translate(-183.385 -174.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M425.519,578.242l4.222,1.157,6.276-16.478-6.231-1.708Z",
    transform: "translate(-28.024 -203.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0,13.757.154l.059,5.526L5.375,5.586A5.569,5.569,0,0,1,0,0H0Z",
    transform: "matrix(-0.967, -0.253, 0.253, -0.967, 408.833, 382.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M525.587,584.181l4.3-.8-.916-17.711-6.341,1.185Z",
    transform: "translate(-90.561 -206.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,.108,13.736,0l-.042,5.534L5.265,5.6A5.324,5.324,0,0,1,0,.108H0Z",
    transform: "translate(448.339 379.759) rotate(169.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M607.613,393.67a4.209,4.209,0,0,1,2.437,2.7,19.584,19.584,0,0,1,.963,4.249c.406,2.7.8,5.626-.044,8.128-.985,2.932-3.611,4.468-5.888,3.746s-4.088-3.431-4.707-6.55a16.527,16.527,0,0,1,1.041-9.338,7.549,7.549,0,0,1,2.724-3.656,2.615,2.615,0,0,1,3.584.781",
    transform: "translate(-181.047 -146.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M573.28,526.948l8.18,76.608-6.756,2.682-12.46-51.372L544.9,601.838l-7.395.43s10.146-73.086,17.665-74.747Z",
    transform: "translate(-140.724 -230.458)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 8.744,
    cy: 9.143,
    rx: 8.744,
    ry: 9.143,
    transform: "translate(416.942 239.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M599.889,429.955l-9.449-1.289s-6.162,7.732-5.751,21.049-1.027,17.4-1.027,17.4l19.7.372C600.515,463.391,612.427,439.873,599.889,429.955Z",
    transform: "translate(-170.451 -168.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M605.336,503.394a3.584,3.584,0,0,0-.588.053L592.66,489.991l1.232-4.3-5.957-2.792-3.7,9.451L601.63,506.82a3.955,3.955,0,0,0,1.965,3.938,3.609,3.609,0,0,0,4.217-.529,4.028,4.028,0,0,0,1.02-4.312,3.746,3.746,0,0,0-3.5-2.523Z",
    transform: "translate(-170.822 -202.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M596.184,440.992l-5.6,14.311,7.806,3.866,6.464-14.163a5.167,5.167,0,0,0,.144-3.924,4.863,4.863,0,0,0-2.629-2.8h0a4.674,4.674,0,0,0-6.186,2.713Z",
    transform: "translate(-174.91 -174.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M586.984,386.578c1.37-.826,1.516-2.82,1.33-4.463s-.5-3.473.426-4.816c1.1-1.6,3.316-1.635,5.2-1.687s4.185-.63,4.674-2.537a3.469,3.469,0,0,0-1.36-3.4,9.319,9.319,0,0,0-3.439-1.473c-2.7-.743-5.484-1.493-8.247-1.084a10.917,10.917,0,0,0-8.958,12.277c.447,3.667,1.1,5.268.67,6.885-.793,3.012-4.212,4.946-4.28,8.069-.053,2.443,2.01,4.327,4.023,5.568a13.153,13.153,0,0,0,5.161,2.049,6.378,6.378,0,0,0,5.192-1.515c1.768-1.682,2.206-4.493,1.7-6.935a21.651,21.651,0,0,0-3.094-6.719",
    transform: "translate(-163.586 -130.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M756.239,494.618H736.3a3.1,3.1,0,0,1-3.026-3.164V470.608a3.1,3.1,0,0,1,3.026-3.164h19.936a3.1,3.1,0,0,1,3.026,3.164v20.846A3.1,3.1,0,0,1,756.239,494.618Z",
    transform: "translate(-266.803 -193.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M849.535,591.792H736.327a2.422,2.422,0,0,1,0-4.839H849.535a2.422,2.422,0,0,1,0,4.839Z",
    transform: "translate(-267.277 -268.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M849.749,560.292H736.541a2.422,2.422,0,0,1,0-4.839H849.749a2.422,2.422,0,0,1,0,4.839Z",
    transform: "translate(-267.415 -248.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M867.273,517.282H850.541a2.422,2.422,0,0,1,0-4.839h16.732a2.422,2.422,0,0,1,0,4.839Z",
    transform: "translate(-340.831 -221.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M923.165,485.292H850.541a2.422,2.422,0,0,1,0-4.839h72.624a2.422,2.422,0,0,1,0,4.839Z",
    transform: "translate(-340.831 -201.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M790.871,623.792H736.327a2.422,2.422,0,0,1,0-4.839h54.544a2.422,2.422,0,0,1,0,4.839Z",
    transform: "translate(-267.277 -288.213)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMydetails);
export default __webpack_public_path__ + "static/media/menu-mydetails.275e678adf702ab60fdaf7c3fe1969a7.svg";
export { ForwardRef as ReactComponent };